
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const WTPPreventiveOperationalWorkExportData = (props) => {
    const { ExcelData, name, FromDate,
        ToDate,
        WardName,
        LocationName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <tr>
                    <td style={{ textAlign: "left", fontSize: 16, fontWeight: 'bold',  }} colSpan={2}>From Date: {moment(FromDate).format('DD-MM-YYYY')}</td>
                    <td style={{ textAlign: "left", fontSize: 16, fontWeight: 'bold' }}>To Date: {moment(ToDate).format('DD-MM-YYYY')}</td>
                </tr>
                <tr>
                    <td style={{ textAlign: "center", fontSize: 16, fontWeight: 'bold' }} colSpan={3}>Ward Name: {WardName}</td>
                </tr>

                <tr>
                    <td style={{ textAlign: "center", fontSize: 16, fontWeight: 'bold' }} colSpan={3}>Location Name: {LocationName}</td>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th className="sr_no_col" style={{ width: 80 }}>Sr No.</th>
                        <th style={{ width: 120 }}>Date</th>
                        <th>Work Name</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item?.workAssignedDate ? moment(item?.workAssignedDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item?.workName ? item?.workName : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}